import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';

const WHATSAPP_NUMBER = "5521980277322";

export const WhatsAppButton = () => {
  return (
    <motion.a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Vim pelo site e preciso de assistência técnica.`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 1, type: "spring" }}
      whileHover={{ scale: 1.1 }}
      style={{
        boxShadow: '0 0 20px rgba(37, 211, 102, 0.5)',
      }}
      data-testid="whatsapp-floating-btn"
    >
      <Phone size={24} className="text-white" />
      
      {/* Pulse animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
    </motion.a>
  );
};

export default WhatsAppButton;
